import React, { SVGProps } from 'react'
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      d="M8.07 4.63a.5.5 0 0 0-.756-.65l-4 4-.049.056a.5.5 0 0 0 .048.651l4 4 .057.049a.5.5 0 0 0 .65-.049l.05-.056a.5.5 0 0 0-.05-.65L4.875 8.832h7.46l.068-.004a.5.5 0 0 0-.068-.996h-7.46l3.147-3.146.048-.056Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgArrowLeft
